<template>
  <span :class="'badge ' + displayStatusUI(row[column.index], 'background')">{{
    displayStatusUI(row[column.index], "text")
  }}</span>
</template>

<script>
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";

export default {
  name: "SortTableDuplicationHistoricStatusCellComponent",
  props: {
    row: {
      type: {},
      required: true,
    },
    column: {
      type: {},
      required: true,
    },
  },
  methods: {
    displayStatusUI(status, type) {
      switch (status) {
        case studeaManagerManager.STUDEA_MANAGER_DUPLICATION_PENDING:
          return type === "background" ? "bg-warning" : this.$t("studea_manager.duplication_status.pending");
        case studeaManagerManager.STUDEA_MANAGER_DUPLICATION_DONE:
          return type === "background" ? "bg-success" : this.$t("studea_manager.duplication_status.done");
        case studeaManagerManager.STUDEA_MANAGER_DUPLICATION_FAILED:
          return type === "background" ? "bg-danger" : this.$t("studea_manager.duplication_status.failed");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
